import { Injectable } from '@angular/core';
import { HttpService } from 'src/app/services/http/http.service';
import { Path } from '../../../utils/constant/paths';

@Injectable({
  providedIn: 'root'
})
export class ChainMaintenanceService {

  constructor(
    private http: HttpService,
  ) { }
    
  getList(data?: any) {
    return this.http.post(Path.CHAIN.GET_LIST, data);
  }
  
  getHandlingFees(data?: any) {
    return this.http.post(Path.CHAIN.GET_HANDLING_FEES, data);
  }
  
  insert(data?: any) {
    return this.http.post(Path.CHAIN.INSERT, data);
  }
  
  insertHandlingFees(data?: any) {
    return this.http.post(Path.CHAIN.INSERT_HANDLING_FEE, data);
  }

  genericMaintenanceDownload(data?: any) {
    return this.http.post(Path.DOWNLOAD.DOWNLOAD_CHAIN_MAINTENACE, data);
  }
}
